/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { isEmpty } from '../../utils/lodashExtend';
import { classnames } from '../../utils/text';
import Icon from '../Icon';
import personIcon from "../../assets/images/icon/person-icon.svg";
import CompaniesModal from './CompaniesModal';
import useForm from '../../hooks/useForm';
import { getCompanies } from '../../apis/companies/companies';
import { get } from 'lodash';

const SearchCompaniesDisplayPanel = ({ companies }) => {
  let displayPanel = <>회사 선택</>;
  if (!isEmpty(companies)) {
    displayPanel = (
      <>
        <span className='inline-block'>{companies[0].name}</span>
        {companies.length > 1 && <span className="inline-block"> 외 {companies.length - 1}개</span>}
      </>
    );
  }
  return displayPanel;
};

const SearchCompanies = ({
  params = {
    type: 2
  },
  className,
  field,
  onChange,
  form,
  disabled,
}) => {

  const [_companies, _setCompanies] = useState(get(form, `${field?.key}`, []));

  const [open, setOpen] = useState(false);

  const _searchCompanies = () => {
    setOpen(true);
  };

  const {
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
  } = useForm(params);


  const submit = () => {
    getCompanies(params).then(res => {
      setList(res.data.map(item => {
        return {
          idx: item.idx,
          name: item.name,
          comNum: item.comNum,
        };
      }));
    }).finally(() => setIsLoading(false));
  };

  useEffect(() => {
    submit();
  }, []);

  const _onChange = () => {
    if (field && field.key && onChange) {
      onChange({ [field.key]: _companies });
    }
  };
  useEffect(() => {
    if (!open) {
      _onChange();
    }
  }, [open]);

  return (
    <>
      <div
        className={classnames("component-select-companies", "cursor-pointer", disabled ? "disabled" : "", className)}
        onClick={_searchCompanies}
      >
        <Icon src={personIcon} className="margin-right-8" />
        <span className="inline-block vertical-middle">
          <SearchCompaniesDisplayPanel companies={_companies} />
        </span>
      </div>


      <CompaniesModal
        isOpen={open}
        setIsOpen={setOpen}
        selectedCompanies={_companies}
        setSelectedCompanies={_setCompanies}
        params={params}
        list={list}
        selectedList={selectedList}
        setSelectedList={setSelectedList}
        isLoading={isLoading}
      />

    </>
  );
};

export default SearchCompanies;